import React from "react";

const Apple = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M18.09 11.194c-1.25 0-3.185-1.437-5.223-1.385-2.688.035-5.154 1.576-6.54 4.017-2.792 4.9-.72 12.138 2.003 16.12 1.335 1.94 2.91 4.122 5 4.052 2.003-.086 2.756-1.316 5.188-1.316 2.414 0 3.099 1.316 5.222 1.264 2.158-.034 3.528-1.973 4.846-3.93 1.524-2.251 2.158-4.433 2.192-4.554-.052-.017-4.195-1.628-4.247-6.476-.034-4.052 3.27-5.99 3.425-6.078-1.884-2.787-4.777-3.099-5.788-3.168-2.637-.208-4.845 1.454-6.078 1.454Zm4.452-4.086C23.655 5.758 24.39 3.87 24.185 2c-1.592.07-3.51 1.074-4.657 2.424-1.027 1.195-1.918 3.117-1.678 4.952 1.764.139 3.579-.917 4.692-2.268Z"
            fill={fill}
        />
    </svg>
);

export default Apple;